import gql from 'graphql-tag';
export const Q_DATA_PRODUCTOS = 'productos';
export const Q_DATA_PLANES = 'planes';
export const queryData = gql`
   query DATA {
      ${Q_DATA_PRODUCTOS} {
         codigo
         denominacion
         productoGlobal
      }
      ${Q_DATA_PLANES} {
         id
         denominacion
         productoPrincipal
         denominacion
         descripcion
         almacenamiento
         nroUsuarios
         precio
         activo
      }
   }
`;
export const Q_MAX_GRUPO_CLIENTE = 'maxGrupoCliente';
export const queryGrupoCliente = gql`
   query grupoCliente($codigoCliente: String!) {
      ${Q_MAX_GRUPO_CLIENTE}(codigo: $codigoCliente) {
         grupo
      }
   }
`;
export const M_REGISTRAR_SUSCRIPCION = 'registrarSuscripcion';
export const mutationRegistrarSuscripcion = gql`
   mutation RegistrarSuscripcion(
      $llave: String!
      $grupo: Int!
      $clienteDenominacion: String!
      $anio: Int!
      $tipoDoc: String!
      $serieDoc: String!
      $nroDoc: String!
      $fechaEmision: DateTime!
      $producto: ID!
      $productoDenominacion: String!
      $cliente: ID!
      $email: String!
      $plan: ID!
      $planDenominacion: String!
      $precio: Float!
      $nroUsuarios: Int!
      $almacenamiento: Float!
      $fechaVigencia: DateTime!
   ) {
      ${M_REGISTRAR_SUSCRIPCION}(
         llave: $llave
         grupo: $grupo
         clienteDenominacion: $clienteDenominacion
         anio: $anio
         tipoDoc: $tipoDoc
         serieDoc: $serieDoc
         nroDoc: $nroDoc
         fechaEmision: $fechaEmision
         producto: $producto
         productoDenominacion: $productoDenominacion
         cliente: $cliente
         email: $email
         plan: $plan
         planDenominacion: $planDenominacion
         precio: $precio
         nroUsuarios: $nroUsuarios
         almacenamiento: $almacenamiento
         fechaVigencia: $fechaVigencia
      ){
         msg
         obs
         error
      }
   }
`;
